import { toast } from 'sonner'

const NETWORK_TOAST_ID = 'dialclear-network-error'
const NETWORK_TOAST_COOLDOWN_MS = 60_000

let lastNetworkToastAt = 0

/** Axios transport failures (no HTTP response): connection refused, aborted, offline, etc. */
export function isTransportNetworkError(error: {
  response?: unknown
  code?: string
  message?: string
}): boolean {
  if (error.response != null) return false
  const code = (error.code ?? '').toUpperCase()
  if (
    code === 'ERR_NETWORK' ||
    code === 'ECONNABORTED' ||
    code === 'ERR_CANCELED' ||
    code === 'ETIMEDOUT'
  ) {
    return true
  }
  const msg = (error.message ?? '').trim().toLowerCase()
  return msg === 'network error' || msg.includes('timeout')
}

/**
 * Show at most one "connection lost" toast per cooldown window.
 * Background polling otherwise floods Sonner during brief API restarts.
 */
export function toastNetworkErrorOnce(message = 'Connection lost. Retrying…'): void {
  const now = Date.now()
  if (now - lastNetworkToastAt < NETWORK_TOAST_COOLDOWN_MS) return
  lastNetworkToastAt = now
  toast.error(message, { id: NETWORK_TOAST_ID, duration: 8_000 })
}
